import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  label: 'Product',
  href: '#features'
}, {
  label: 'Workflows',
  href: '#workflows'
}, {
  label: 'Integrations',
  href: '#integrations'
}, {
  label: 'Security',
  href: '#security'
}];
const LOGIN_URL = 'https://app.pigeondocuments.com/login';
const BOOK_A_CALL_URL = 'https://calendly.com/pigeondocuments';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${scrolled ? 'border-b border-white/[0.06] bg-zinc-950/70 backdrop-blur-xl supports-[backdrop-filter]:bg-zinc-950/55' : 'border-b border-transparent'}`} data-id="element-498">
      <nav className="mx-auto flex w-full max-w-7xl items-center justify-between px-6 py-3.5 lg:px-8" aria-label="Main" data-id="element-499">
        <a href="/" className="flex items-center gap-2 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-accent/50" data-id="element-500">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3Ti5Jr9Zm1LRNz51qTKsea/1.png" alt="" aria-hidden className="h-7 w-auto" data-id="element-501" />
          <span className="text-[1.2rem] font-semibold leading-none tracking-tight text-white sm:text-[1.35rem]" data-id="element-502">
            Pigeon
          </span>
        </a>

        <ul className="hidden items-center gap-8 lg:flex" data-id="element-503">
          {links.map(l => <li key={l.label} data-id="element-504">
              <a href={l.href} className="rounded text-[13px] text-zinc-400 outline-none transition-colors duration-200 hover:text-white focus-visible:ring-2 focus-visible:ring-accent/50" data-id="element-505">
                {l.label}
              </a>
            </li>)}
        </ul>

        <div className="hidden items-center gap-2 lg:flex" data-id="element-506">
          <a href={LOGIN_URL} target="_blank" rel="noopener noreferrer" className="btn-ghost" data-id="element-507">
            Log In
          </a>
          <a href={BOOK_A_CALL_URL} target="_blank" rel="noopener noreferrer" className="btn-primary" data-id="element-508">
            Book a Call
          </a>
        </div>

        <button onClick={() => setOpen(!open)} className="rounded-md p-1 text-white outline-none focus-visible:ring-2 focus-visible:ring-accent/50 lg:hidden" aria-label="Toggle menu" aria-expanded={open} data-id="element-509">
          {open ? <XIcon className="h-6 w-6" data-id="element-510" /> : <MenuIcon className="h-6 w-6" data-id="element-511" />}
        </button>
      </nav>

      <AnimatePresence initial={false} data-id="element-512">
        {open && <motion.div key="mobile-menu" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.32,
        ease: [0.16, 1, 0.3, 1]
      }} className="overflow-hidden border-t border-white/[0.06] bg-zinc-950/95 backdrop-blur-xl lg:hidden" data-id="element-513">
            <div className="space-y-1 px-5 py-3" data-id="element-514">
              {links.map((l, i) => <motion.a key={l.label} href={l.href} onClick={() => setOpen(false)} initial={{
            opacity: 0,
            y: -6
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.06 + i * 0.04,
            ease: [0.16, 1, 0.3, 1]
          }} className="flex min-h-[44px] items-center rounded-lg px-3 text-base text-zinc-200 outline-none active:bg-white/[0.04] focus-visible:ring-2 focus-visible:ring-accent/50" data-id="element-515">
                  {l.label}
                </motion.a>)}
              <motion.a href={LOGIN_URL} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} initial={{
            opacity: 0,
            y: -6
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.06 + links.length * 0.04,
            ease: [0.16, 1, 0.3, 1]
          }} className="flex min-h-[44px] items-center rounded-lg px-3 text-base text-zinc-200 outline-none active:bg-white/[0.04] focus-visible:ring-2 focus-visible:ring-accent/50" data-id="element-516">
                Log In
              </motion.a>
              <motion.div initial={{
            opacity: 0,
            y: -6
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.06 + (links.length + 1) * 0.04,
            ease: [0.16, 1, 0.3, 1]
          }} className="mt-3 border-t border-white/[0.06] pt-3" data-id="element-517">
                <a href={BOOK_A_CALL_URL} target="_blank" rel="noopener noreferrer" className="btn-primary w-full justify-center" data-id="element-518">
                  Book a Call
                </a>
              </motion.div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}